import { RouteProps } from 'react-router';
import { NctActions } from './index';
import ChangeEmailSuccess from './ChangeEmail/change-email-success';
import ChangeDividend from './ChangeIdcw';
import ChangeDividendOtp from './ChangeIdcw/change-dividend-otp';
import ChangeEmail from './ChangeEmail';
import ChangeEmailDocument from './ChangeEmail/change-email-document';
import ChangeEmailList from './ChangeEmail/change-email-list';
import ChangeEmailOtp from './ChangeEmail/change-email-otp';
import ChangeMobileOTP from './ChangeEmail/authVerify';
import ChangeMobile from './ChangeMobile';
import ChangeMobileDocument from './ChangeMobile/change-mobile-document';
import ChangeMobileNew from './ChangeMobile/newMobile';
import ChangeMobileSuccess from './ChangeMobile/change-mobile-success';
import UpdateNominee from './UpdateNominee';
import UpdateNomineeEdit from './UpdateNominee/update-nominee-edit';
import UpdateNomineeOtp from './UpdateNominee/update-nominee-otp';
import UpdateNomineeSuccess from './UpdateNominee/update-nominee-success';
import UpdateNomineeFailure from './UpdateNominee/update-nominee-failed';
import ConsolidationFolios from './ConsolidationFolios';
import ChangeBank from './ChangeBank';
import ChangeBankSelected from './ChangeBank/change-bank-selected';
import ChangeBankSuccess from './ChangeBank/change-bank-success';
import ChangeBankDocument from './ChangeBank/change-bank-document';
import OtpVerification from './ChangeMobile/otp';
import ConsolidationFoliosOtp from './ConsolidationFolios/consolidation-folios-otp';
import ConsolidationFoliosSuccess from './ConsolidationFolios/consolidation-folios-success';
import ConsolidationFoliosFailure from './ConsolidationFolios/consolidation-folios-failed';
import ChangeTaxStatus from './ChangeTaxStatus';
import ChangeTaxUpload from './ChangeTaxStatus/change-tax-upload';
import ChangeTaxOtp from './ChangeTaxStatus/change-tax-otp';
import ChangeTaxSuccess from './ChangeTaxStatus/change-tax-success';
import ChangeTaxStatusBankDetails from './ChangeTaxStatus/change-bank-details';
import UpdateForm15 from './UpdateForm15';
import UpdateForm15Otp from './UpdateForm15/update-form15-otp';
import UpdateForm15List from './UpdateForm15/update-form15-list';
import UpdateForm15Income from './UpdateForm15/update-form15-income';
import UpdateForm15Success from './UpdateForm15/update-form15-success';
import MinorStatus from './MinorStatus';
import MinorStatusReview from './MinorStatus/minor-status-review';
import MinorStatusSuccess from './MinorStatus/minor-status-success';
import MinorStatusPan from './MinorStatus/minor-status-pan';
import MinorUpdateNomineeEdit from './MinorStatus/minor-status-nominee';
import CorrectionFolios from './CorrectionFolios';
import CorrectionFoliosSelection from './CorrectionFolios/correction-folios-selection';
import ChangeDividendSuccess from './ChangeIdcw/change-dividend-success';
import ConsolidationSourceFolios from './ConsolidationFolios/consolidationSourceFolios';
import CorrectionFoliosOtp from './CorrectionFolios/correction-folios-otp';
import CorrectionFoliosSuccess from './CorrectionFolios/correction-folios-success';
import CorrectionFoliosFailure from './CorrectionFolios/correction-folios-failed';
import UpdateIFSC from './UpdateIFSC';
import UpdateIFSCDetails from './UpdateIFSC/update-ifsc-details';
import UpdateIFSCOtp from './UpdateIFSC/update-ifsc-otp';
import UpdateIFSCSuccess from './UpdateIFSC/update-ifsc-success';
import BankMandate from './BankMandate';
import BankMandateSelected from './BankMandate/bank-mandate-selected';
import BankMandateSuccess from './BankMandate/bank-mandate-success';
import BankMandateFailure from './BankMandate/bank-mandate-failed';
import BankMandateOtp from './BankMandate/bank-mandate-otp';
import BankMandateDeleteSelected from './BankMandate/bank-mandate-delete-selected';
import FatcaDeclaration from './FatcaDeclaration';
import FatcaDeclarationOtp from './FatcaDeclaration/fatca-declaration-otp';
import FatcaDeclarationSuccess from './FatcaDeclaration/fatca-declaration-success';
import { MinorStatusList } from './MinorStatus/minor-status-list';
import MinorStatusEditBank from './MinorStatus/minor-status-edit-bank';
import minorStatusOtp from './MinorStatus/minor-status-otp';
import bankMandateAddBank from './BankMandate/bank-mandate-add-bank';
import changeBankOtp from './ChangeBank/change-bank-otp';
import Transmission from './Transmission';
import TransmissionList from './Transmission/list';
import TransmissionPan from './Transmission';
import { PostTransmissionDownload } from './Transmission/transmission-download';
import { PostTransmissionDownloadList } from './Transmission/transmission-download-list';
import PostTransmissionRequestOtp from './Transmission/transmission-download-otp';
import PostTransmissionSuccess from './Transmission/transmission-request-success';
import AuthVerify from './ChangeMobile/authVerify';
import { TransferOfUnits } from './TransferOfUnits';
import LockUnlockFolios from './LockUnlockFolios';
import LockUnlockFoliosOtp from './LockUnlockFolios/lock-unlock-folios-otp';
import LockUnlockFoliosSuccess from './LockUnlockFolios/lock-unlock-folios-success';

// import CorrectionFolios from './CorrectionFolios';
// import CorrectionFoliosSelection from './CorrectionFolios/correction-folios-selection';

export const NctRoutes: RouteProps[] = [
    {
        path: `/actions`,
        component: NctActions,
    },
    {
        path: `/change-email`,
        component: ChangeEmail,
    },
    {
        path: `/change-email-otp`,
        component: ChangeEmailOtp,
    },
    {
        path: `/change-email-list`,
        component: ChangeEmailList,
    },
    {
        path: `/change-email-success`,
        component: ChangeEmailSuccess,
    },
    {
        path: `/change-email-document`,
        component: ChangeEmailDocument,
    },
    {
        path: `/change-dividend`,
        component: ChangeDividend,
    },
    {
        path: `/change-dividend-otp`,
        component: ChangeDividendOtp,
    },
    {
        path: `/change-dividend-success`,
        component: ChangeDividendSuccess,
    },
    {
        path: '/change-mobile',
        component: ChangeMobile,
    },
    {
        path: '/change-mobile-auth',
        component: AuthVerify,
    },
    {
        path: '/change-mobile-document',
        component: ChangeMobileDocument,
    },
    {
        path: '/change-mobile-new',
        component: ChangeMobileNew,
    },
    {
        path: '/change-email-auth',
        component: ChangeMobileOTP,
    },
    {
        path: '/otp-verification',
        component: OtpVerification,
    },
    {
        path: '/change-mobile-success',
        component: ChangeMobileSuccess,
    },
    {
        path: '/update-nominee',
        component: UpdateNominee,
    },
    {
        path: '/update-nominee-edit',
        component: UpdateNomineeEdit,
    },
    {
        path: '/update-nominee-edit-otp',
        component: UpdateNomineeOtp,
    },
    {
        path: '/update-nominee-success',
        component: UpdateNomineeSuccess,
    },
    {
        path: '/update-nominee-failed',
        component: UpdateNomineeFailure,
    },
    {
        path: '/change-bank',
        component: ChangeBank,
    },
    {
        path: '/change-bank-selected',
        component: ChangeBankSelected,
    },
    {
        path: '/change-bank-otp',
        component: changeBankOtp,
    },
    {
        path: '/change-bank-document',
        component: ChangeBankDocument,
    },
    {
        path: '/change-bank-success',
        component: ChangeBankSuccess,
    },
    {
        path: '/consolidation-folios',
        component: ConsolidationFolios,
    },
    {
        path: '/consolidation-folios-otp',
        component: ConsolidationFoliosOtp,
    },
    {
        path: '/consolidation-folios-success',
        component: ConsolidationFoliosSuccess,
    },
    {
        path: '/consolidation-folios-failed',
        component: ConsolidationFoliosFailure,
    },
    {
        path: '/change-tax',
        component: ChangeTaxStatus,
    },
    {
        path: '/change-tax-upload',
        component: ChangeTaxUpload,
    },
    {
        path: '/change-tax-otp',
        component: ChangeTaxOtp,
    },
    {
        path: '/change-tax-success',
        component: ChangeTaxSuccess,
    },
    {
        path: '/tax-bank-details',
        component: ChangeTaxStatusBankDetails,
    },
    // {
    //     path: '/update-form15',
    //     component: UpdateForm15,
    // },
    {
        path: '/update-form15-otp',
        component: UpdateForm15Otp,
    },
    {
        path: '/update-form15-list',
        component: UpdateForm15List,
    },
    {
        path: '/update-form15-income',
        component: UpdateForm15Income,
    },
    {
        path: '/update-form15-success',
        component: UpdateForm15Success,
    },
    {
        path: '/minor-status',
        component: MinorStatus,
    },
    {
        path: '/minor-status-nominee',
        component: MinorUpdateNomineeEdit
    },
    {
        path: '/minor-status-pan',
        component: MinorStatusPan,
    },
    {
        path: '/minor-status-review',
        component: MinorStatusReview,
    },
    {
        path: '/minor-status-list',
        component: MinorStatusList,
    },
    {
        path: '/minor-status-edit-bank',
        component: MinorStatusEditBank,
    },
    {
        path: '/minor-status-otp',
        component: minorStatusOtp,
    },
    {
        path: '/minor-status-success',
        component: MinorStatusSuccess,
    },
    {
        path: '/corrections-folios',
        component: CorrectionFolios,
    },
    {
        path: '/correction-folios-selection',
        component: CorrectionFoliosSelection,
    },
    {
        path: '/consolidate-source-folios',
        component: ConsolidationSourceFolios,
    },
    {
        path: '/correction-folios-otp',
        component: CorrectionFoliosOtp,
    },
    {
        path: '/correction-folios-success',
        component: CorrectionFoliosSuccess,
    },
    {
        path: '/correction-folios-failed',
        component: CorrectionFoliosFailure,
    },
    {
        path: '/update-ifsc',
        component: UpdateIFSC,
    },
    {
        path: '/update-ifsc-details',
        component: UpdateIFSCDetails,
    },
    {
        path: '/update-ifsc-otp',
        component: UpdateIFSCOtp,
    },
    {
        path: '/update-ifsc-success',
        component: UpdateIFSCSuccess,
    },
    {
        path: '/bank-mandate',
        component: BankMandate,
    },
    {
        path: '/bank-mandate-selected',
        component: BankMandateSelected,
    },
    {
        path: '/bank-mandate-otp',
        component: BankMandateOtp,
    },
    {
        path: '/bank-mandate-delete-selected',
        component: BankMandateDeleteSelected,
    },
    {
        path: '/bank-mandate-add-bank',
        component: bankMandateAddBank,
    },
    {
        path: '/bank-mandate-success',
        component: BankMandateSuccess,
    },
    {
        path: '/bank-mandate-failed',
        component: BankMandateFailure,
    },
    {
        path: '/fatca-declaration',
        component: FatcaDeclaration,
    },
    {
        path: '/fatca-declaration-otp',
        component: FatcaDeclarationOtp,
    },
    {
        path: '/fatca-declaration-success',
        component: FatcaDeclarationSuccess,
    },
    {
        path: '/transmission-pan',
        component: TransmissionPan,
    },
    {
        path: '/transmission-list',
        component: TransmissionList,
    },
    {
        path: '/transmission-download',
        component: PostTransmissionDownload,
    },
    {
        path: '/transmission-download-list',
        component: PostTransmissionDownloadList,
    },
    {
        path: '/transmission-download-otp',
        component: PostTransmissionRequestOtp,
    },
    {
        path: '/transmission-request-success',
        component: PostTransmissionSuccess,
    },
    {
        path: '/transfer-of-units',
        component: TransferOfUnits,
    },
    {
        path: '/lock-unlock-folios',
        component: LockUnlockFolios,
    },
    {
        path: '/lock-unlock-folios-otp',
        component: LockUnlockFoliosOtp,
    },
    {
        path: '/lock-unlock-folios-success',
        component: LockUnlockFoliosSuccess,
    }
];
